import * as React from 'react';
import ModalContext from '../ModalContext';
import TargetWrapper from '../TargetWrapper';
export class FlyoutTarget extends React.Component {
    render() {
        const { id, children } = this.props;
        return (React.createElement(ModalContext.Consumer, null, ({ modalId, isOpen, hideTarget, modalType, props }) => {
            return isOpen && modalId === id && modalType === 'flyout' ? (React.createElement(TargetWrapper, { isOpen: isOpen, modalType: modalType, hideTarget: hideTarget, preventOverflow: props.preventOverflow }, children)) : null;
        }));
    }
}
export default FlyoutTarget;
//# sourceMappingURL=FlyoutTarget.js.map